"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["PRODUCTS"] = "products";
    PageType["PAGES"] = "pages";
    PageType["BOOKING"] = "booking";
})(PageType || (exports.PageType = PageType = {}));
//# sourceMappingURL=PageType.js.map